module.exports = __webpack_public_path__ + "img/titlebg_purple.5eb939ab.png";